import { styled } from "@mui/material";

export const ActionTopBoxStyled = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  maxWidth: "270px",
});
